// extracted by mini-css-extract-plugin
module.exports = {"lighter":"Record_lighter_2wGGc","record":"Record_record_3WP2S","mask":"Record_mask_3jaw2","context":"Record_context_gt__Q","window":"Record_window_2Pnc_","col":"Record_col_xMpTH"};